import React from "react";
import "./LanguageSelector.scss";
import { Dropdown } from "react-bootstrap";
import i18n from "i18next";
import { languageIcons, languages } from "../../api/ReplayVariables";

function LanguageSelector() {
  const switchLanguage = (lang) => {
    document.location.href = document.location.href.replace(
      "/opencards/" + i18n.language + "/",
      "/opencards/" + lang + "/"
    );
  };

  return (
    <Dropdown className="language-selector">
      <Dropdown.Toggle className="d-flex">
        <img src={languageIcons[i18n.language]} alt={i18n.language} />
      </Dropdown.Toggle>
      <Dropdown.Menu className="language-selector-menu">
        {languages.map((language) => (
          <Dropdown.Item
            key={language}
            eventKey={language}
            onClick={() => switchLanguage(language)}
          >
            <img src={languageIcons[language]} alt={language} />
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
}
export default LanguageSelector;
